export default __webpack_public_path__ + "static/media/1.aa2fb709.png";